/* eslint-disable max-len */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable object-shorthand */
import { Component, ViewChild } from '@angular/core';
import {
  NavParams,
  ModalController,
  AlertController,
  ActionSheetController,
  LoadingController,
  MenuController
} from '@ionic/angular';
import { AuthService } from '../services/auth.service';
import { CurbUser, User_global } from '../../app/app.models';
// import { CameraProvider } from '../services/camera';
import { CommonProvider } from './../services/common';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ConnectionsService } from '../services/connections.service';
import { NetworkProvider } from '../services/network';
import { SMSService } from '../services/sms.service';
import { Router } from '@angular/router';
import { EditInputPage } from '../components/edit-input/edit-input';
import aa from 'search-insights';
import { LocationService } from '../services/location.service';
import { AlgoliaFilterHitsFn, AlgoliaHit, AlgoliaInstanceNames } from '../constants/algolia';
import { AlgoliaAutomaticSearch } from '../components/algolia-automatic-search/algolia-automatic-search';

@Component({
  selector: 'app-my-paired-lenders',
  templateUrl: 'my-paired-lenders.html',
  styleUrls: ['./my-paired-lenders.scss'],
  standalone: false
})
export class MyPairedLendersPage {

  userData: CurbUser;
  env: any = {};
  userSubs: any;
  myLendersSubs: any = {};
  myPairedLenders: any = [];
  myPairedLendersInvites: any = [];
  uid: string;
  myAdminInvites: any = [];

  webhookSent = false;
  inviteEmail = '';
  showLenders = false;
  loading = true;
  alreadyConnected = false;
  initialized = false;
  loadInterval: any;
  userRole: string;
  currentLocationView = '';  //searchZipCodeView, enterZipCodeView, currentZipCodeView
  geoLocationCordinates;
  geoZipcode;
  radiusSearch = 100;
  offlineMode = false;
  algoliaLoading = false;

  userZipcode = '';
  userCountry = '';

  @ViewChild('algoliaAutomaticLenderSearch', { static: false }) algoliaAutomaticSearch: AlgoliaAutomaticSearch;
  instanceName = AlgoliaInstanceNames.my_paired_lenders_automatic_search_for_lenders;
  filterHitsFn: AlgoliaFilterHitsFn = this.notInInviteList.bind(this);

  constructor(
    public navCtrl: Router,
    public navParams: NavParams,
    private auth: AuthService,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public actionSheetCtrl: ActionSheetController,
    public modalCtrl: ModalController,
    public common: CommonProvider,
    // public cameraProvider: CameraProvider,
    private userConnectionsService: ConnectionsService,
    private network: NetworkProvider,
    private messageService: SMSService,
    private menu: MenuController,
    private locationService: LocationService
  ) {
    console.log('paired lender constructor');
  }

  async ngAfterViewInit() {


    aa('init', {
      appId: environment.algolia.appId,
      apiKey: environment.algolia.apiKey
    });

    this.common.startLoading();

    this.auth.userInitialized$
      .pipe(
        filter(initialized => initialized === true),
        take(1)
      )
      .subscribe(() => {
        console.log('paired lenders init.');
        this.initPairedLenders();
      });
  }

  async initPairedLenders() {

    this.userCountry = (await this.locationService.getCurrentLocation()).country_code;

    console.log('paired lenders page enter');
    this.loading = true;
    this.userData = User_global;
    this.env = environment;

    console.log('initPairedLenders');
    this.uid = this.auth.getUID();
    this.menu.enable(true);
    this.menu.swipeGesture(true, 'left');

    const self = this;

    // this.userSubs = combineLatest(this.auth.userDataObserver(), (user) => ({ user })).subscribe((data) => {

    this.userSubs = combineLatest([this.auth.userDataObserver()]).pipe(
      map(([user]) => ({ user }))).subscribe((data) => {

        setTimeout(() => { this.common.closeLoading(); this.loading = false; }, 3000);

        console.log('combineLatest');
        if (this.network.checkInternet()) {
          this.offlineMode = false;
        }
        else {
          this.offlineMode = true;
        }

        if (data && data.user) {
          console.log('user data subscribe: ' + JSON.stringify(data));
          self.userData = data.user;


          if (data.user.address && data.user.address.zip !== this.userZipcode) {
            this.userZipcode = data.user.address.zip;

            if (data.user.address.zip) {
              this.userZipcode = data.user.address.zip;
              this.currentLocationView = 'currentZipCodeView'; //searchZipCodeView, enterZipCodeView, currentZipCodeView

              this.auth.restrictedRecommendStates().then(res => {
                console.log('restrict states :' + JSON.stringify(res.states));
                this.auth.restrictedRecommendStatesArray = res.states;
                this.searchRecommendedLenders();
              });
            }
            else if (!User_global.address || !User_global.address.zip) {
              this.currentLocationView = 'enterZipCodeView';
              this.auth.restrictedRecommendStates().then(res => {
                this.auth.restrictedRecommendStatesArray = res.states;
              });
            }
          }
          else if (!data.user.address || !data.user.address.zip) {
            this.currentLocationView = 'enterZipCodeView';
            this.auth.restrictedRecommendStates().then(res => {
              this.auth.restrictedRecommendStatesArray = res.states;
            });
          }
        }

      });

    this.myLendersSubs = this.userConnectionsService.connections().subscribe((data) => {
      console.log('my paired lenders data: ' + JSON.stringify(data));

      setTimeout(() => { this.common.closeLoading(); this.loading = false; }, 3000);


      if (data) {


        self.myAdminInvites = data.filter(agent => agent.status === 'invited' && agent.role === 'agentAdmin');


        self.myPairedLenders = data.filter(agent => agent.status === 'active' && !agent.regionalLender);
        self.myPairedLendersInvites = data.filter(agent =>
          (agent.status === 'invited'
            || agent.status === 'lender_invited_agent'
            || agent.status === 'agent_invited_lender')
          && !agent.regionalLender
          && agent.role !== 'agentAdmin'
        );

        self.myPairedLendersInvites.sort(function (a, b) {
          return a.status === 'agent_invited_lender'
            && b.status === 'lender_invited_agent' ? 1 : -1;
        });

        self.myPairedLendersInvites.sort(function (a, b) {
          return a.status === 'invited'
            && b.status === 'agent_invited_lender' ? 1 : -1;
        });

        self.myPairedLendersInvites.sort(function (a, b) {
          return a.status === 'invited'
            && b.status === 'lender_invited_agent' ? 1 : -1;
        });

        if (self.myPairedLenders.length > 0) {
          self.showLenders = true;
        }
        else {
          self.showLenders = false;
        }

        // find out if already connected
        if (self.myPairedLenders.length > 0 && self.myPairedLendersInvites.length > 0) {
          self.alreadyConnected = true;
        }
        else {
          self.alreadyConnected = false;
          // this.currentLocationView = 'enterZipCodeView';
        }
      }
      else {
        //    this.currentLocationView = 'enterZipCodeView';
      }
    });


    this.initialized = true;
    this.userRole = User_global.role;

    setTimeout(() => {
      if (this.userRole !== 'agent') {
        console.log('User Role', this.userRole);
        this.navCtrl.navigate(['/my-paired-agents']);
        return;
      }
    }, 10000);

    aa('setUserToken', this.auth.getUID());
  }

  ngOnDestroy() {

    clearInterval(this.loadInterval);

    console.log('unsubscribe paired lender');
    if (this.userSubs) {
      this.userSubs.unsubscribe();
      this.userSubs = null;
    }
  }

  openMyProfile() {
    console.log('open my profile');
    this.navCtrl.navigate(['/my-profile']);
  }

  openHelp() {
    if (!this.network.checkInternet()) {
      this.navCtrl.navigate(['/help']);
    }
    else {
      this.common.showHelpPage();
    }
  }

  sendEmailWebhook() {

    this.webhookSent = true;

    this.messageService.sendEmailWebhook(this.inviteEmail).then(res => {

      if (res) {
        this.inviteEmail = '';
        this.common.toast('Email sent to your lender!');
      }
      else {
        this.auth.logErrors('Error inviting lender 3: ' + this.inviteEmail);
        this.common.showDBWriteError();
      }
    }, (err) => {
      console.log('webhook error : ' + err);
      this.auth.logErrors('Error inviting lender 5: ' + this.inviteEmail + ' error: ' + JSON.stringify(err));
      this.common.showDBWriteError();
    });
  }

  copyReferral() {
    this.common.copyToClipboard(environment.referralURL + this.userData.referralCode);
  }

  learnMore(val) {
    this.common.openLink('https://juuj.me/real-estate-agents-invite-lender');
  }

  async enterLocation() {

    if (this.algoliaLoading) {
      return;
    }
    if (!this.network.checkInternet()) {
      this.network.noNetworkModal();
      return;
    }

    const inputModal = await this.modalCtrl.create({
      component: EditInputPage, componentProps: {
        displayCountryPicker: true,
        selectedCountry: this.userCountry,
        label: 'Location',
        data: this.userZipcode,
        placeholder: 'Zip/Postal Code or Similar Location',
        helperText: 'Zip code or postal codes are strongly recommended. If entering a city name, also include state or region (ex: Beverly Hills, California).',
        //  limit: 5,
        //  numericInput: true
      }
    });

    await inputModal.present();
    const { data } = await inputModal.onWillDismiss() as { data: { country: string, zipOrAddress: string } };

    console.log('dismiss ' + data);
    if (data === undefined || data === null) {
      return;
    }

    // When we opened the modal, we passed the current location, but the user may have changed it from the country picker
    this.userCountry = data.country;
    this.userZipcode = data.zipOrAddress;

    this.searchRecommendedLenders(true); // force geo change
  }

  async searchRecommendedLenders(forceReload = false) {
    if (!this.userZipcode) {
      console.log('no user zip code returning');
      return;
    }

    this.algoliaLoading = true;
    const result = await this.locationService.getCoordsFromAddressOrZip(this.userZipcode, this.userCountry, this.userData, forceReload);
    this.algoliaLoading = false

    if (result.length > 1) {
      let customFilter = '';
      const restrictedStates = this.auth.restrictedRecommendStatesArray;

      for (let i = 0; i < restrictedStates.length; i++) {
        console.log(restrictedStates[i]);
        customFilter += `(NOT locations.lvl0: ${restrictedStates[i]})`;

        if (i !== restrictedStates.length - 1) {
          customFilter += ' AND ';
        }
      }

      customFilter += ` AND (NOT regionalLender: 'true')`; // no regional lenders  

      console.log('Location result[0] + ', ' + result[1]', result[0] + ',' + result[1]);
      const updateConfigs = {
        aroundLatLng: result[0] + ',' + result[1],
        aroundRadius: this.radiusSearch * 1000, // in multipes of 1 km
        hitsPerPage: 6,
        filters: customFilter
      } as any;

      if (this.algoliaAutomaticSearch) {
        this.algoliaAutomaticSearch.updateConfigs(updateConfigs);
        console.log('algolia search updated config');
      }
      else {
        console.log('algoliaAutomaticSearch' + ' does not exist');
      }

    }

    this.currentLocationView = 'currentZipCodeView';
  }

  inviteClicked(hit: AlgoliaHit) {
    if (this.algoliaAutomaticSearch) {
      this.algoliaAutomaticSearch.sendEvent('click', hit, 'recommendationClick', {
        objectIDs: [hit.objectID],
        userToken: this.uid
      });
    }
  }

  notInInviteList(id) {
    return !this.myPairedLendersInvites.find(x => x.id === id) && !this.myPairedLenders.find(x => x.id === id);
  }
}
